

$(function () {
    $(".chart-distribution").each(function (idx, element) {
        var $canvas = $(element).find("canvas");
        var canvas = $canvas.get(0);
        var ctx = canvas.getContext("2d");
        var dataUrl = $(element).data("url");
        var $spinner = $(element).children(".chart-distribution-spinner");
        var $container = $(element).children(".row");
        var chart = null;
        var id = $(element).attr("id");
        var $legend = $("#" + id + "Legend");
        var $lastUpdated = $(element).find("[stems-date]");

        var _generateColors = function (data) {
            if (data && data.length > 0 && data[0].Color) {
                var colors = [];

                for (var i = 0; i < data.length; i++) {
                    colors.push(data[i].Color);
                }

                return colors;
            }

            return ['#F44336', '#CDDC39', '#9C27B0', '#3F51B5', '#03A9F4'
                , '#009688', '#4CAF50', '#E91E63', '#FF9800', '#795548', '#9E9E9E']
                .shuffle();
        };

        var _createDateStamp = function (millis) {
            $lastUpdated.attr("stems-date", millis);
        };

        var _createLegend = function (chart) {
            var legend = chart.generateLegend();
            $legend.html(legend);

            $legend.find("li").click(function () {
                var idx = $(this).index();
                var meta = chart.getDatasetMeta(0);
                var item = meta.data[idx];
                var removed = $(this).hasClass("removed");

                if (removed) {
                    $(this).removeClass("removed");
                    item.hidden = false;
                }
                else {
                    $(this).addClass("removed");
                    item.hidden = true;
                }

                chart.update();
            });
        }

        var _createPieChart = function (data) {
            var colors = _generateColors(data.DataItems);

            return new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: $.map(data.DataItems || data.dataItems, function (item) {
                        return (item.DataItem || item.dataItem).toString();
                    }),
                    datasets: [{
                        label: 'Distribution Chart',
                        data: $.map(data.DataItems || data.dataItems, function (item) {
                            return item.Value || item.value;
                        }),
                        backgroundColor: colors,
                        borderColor: colors
                    }]
                },
                options: {
                    responsive: false,
                    legend: {
                        display: false
                    },
                    animation: {
                        duration: 1000,
                        animateScale: true,
                        animateRotate: true
                    },
                    tooltips: {
                        xPadding: 12,
                        yPadding: 12,
                        displayColors: false
                    }
                }
            });
        }

        var _render = function (data) {
            chart = _createPieChart(data);
            _createLegend(chart);
            _createDateStamp(data.LastUpdated || data.lastUpdated);
        }

        var _fetchSuccess = function (d) {
            $spinner.hide();
            $container.show();

            _render(d);
        };

        var _fetch = function () {

            $.ajax({
                url: dataUrl,
                method: "GET",
                success: function (d) { _fetchSuccess(d); },
                error: function (x, s, e) {
                    //TODO: handle error
                }
            });
        };

        _fetch();
    });
});